<template>
    <div class="market_import">
        <b-overlay :show="is_load">


            <div class="choose_type pb-4">
                <yes_no
                    key="IMPORT_TYPE"
                    v-model="load_type"
                    :radio_options="radio_options"
                    title="IMPORT_TYPE">
                </yes_no>
            </div>


            <div class="options">
                <div class="panel-tag mt-2">
                    {{__t('MARKET_REQUIRED_OPTIONS')}}
                </div>

                {{form_params}}
                <div class="required_options" v-if="form_params">
                    <div class="form-group" v-for="(param) in form_params">
                        <label class="form-label">
                            {{ __t(param.name.toUpperCase()) }}
                        </label>

                        <div class="input-group input-group-lg bg-white shadow-inset-2 with_icon">

                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-left-0 border-right-0 py-1 px-3">
                                    <span class="icon-stack fs-xxl">
                                        <i class="base-7 icon-stack-3x color-primary-500"></i>
                                        <i class="fal fa-database icon-stack-1x text-white"></i>
                                    </span>
                                </span>
                            </div>

                            <b-form-input
                                debounce="300"
                                class="form-control  bg-transparent pl-5"
                                :key="param.type"
                                :id="'pos_param_' + param.type"
                                v-model="param.value"
                            >
                            </b-form-input>
                        </div>
                    </div>
                </div>
            </div>

            <div class="list_mem_create p-4">
                <div class="panel-container show" v-if="work_obj.isLoaded">
                    <div class="panel-content">
                        <table class="table table-stripped" v-if="work_obj.isLoaded">
                            <thead>
                            <tr>
                                <th width="35px">#</th>
                                <th>{{ __t('FEED_TYPE') }}</th>
                                <th>{{ __t('FEED_QTY') }}</th>
                                <th>{{ __t('FEED_STATUS') }}</th>
                            </tr>
                            </thead>

                            <tbody>
                            <template v-for="(item_feed,type) in this.feed">
                                <tr>
                                    <td>
                                        {{ item_feed.number }}
                                    </td>

                                    <td>
                                        {{ __t(item_feed.human_name) }}
                                    </td>

                                    <td>
                                        <b-badge variant="success">
                                            {{ item_feed.count_ok }}
                                        </b-badge>
                                        /
                                        <b-badge variant="danger">
                                            {{ item_feed.count_err }}
                                        </b-badge>
                                        /
                                        <b-badge variant="info">
                                            {{ item_feed.count_all }}
                                        </b-badge>

                                    </td>
                                    <td>
                                        {{ item_feed.status }}
                                    </td>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="action mt-5">
                <div  class="products_in">
                    <div  class="button_add mb-4" v-on:click="sync">
                        <button :disabled="!can_sync || work_obj.isRunning"  class="btn btn-md btn-block btn-outline-info waves-effect waves-themed">
                            <span  class="fal  fa-eject mr-1"></span>
                            {{ __t('SYNC_CATALOG') }}
                        </button>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import Yes_no from "../../../../sys/radio/yes_no.vue";

export default {
    name: "export_worker",
    components: {Yes_no},
    props : {
        provider : {
            type : Object,
            default : {}
        },
    },

    data() {
        return {
            is_load : false,
            load_type : "default",
            form_params : [],

            prov_id : 63,

            //Feed Data
            options: {
                batchSize: 3,
                retry: false
            },

            timer: {
                seconds: 0,
                interval: null,
            },

            work_obj: {
                step_name: "",
                isRunning: false,
                isSyncRun:false,
                isSynced: false,
                isLoaded: false,
                isFileFeed  : false,
                request_cancel: null,
                token: null,
                is_in_socket : false,
            },
            feed: [],

            cur_org_id : "",
        }
    },


    created() {

        if (this.provider && this.provider.params && Array.isArray(this.provider.params.parameters)) {
            this.form_params = this.provider.params.parameters.map(param => ({
                ...param,
                value: ''
            }));
        }

       /* this.work_provider = this.provider;
        this.market_params.forEach(param => {
            if (typeof param.value === 'undefined') {
                this.$set(param, 'value', '');
            }
        });*/
    },

    methods: {

        async sync() {
            this.is_load = true;

            let self = this;
            this.work_obj.isRunning = true;
            this.work_obj.step_name = 'INIT';
            this.feed = [];

            pos_api.post('/pos/'+ this.prov_id +'/organizations/'+ this.provider.type +'/feed',{
                "menu_type" : this.load_type,
                "market_in" : this.provider.type,
                "params" : this.form_params.map(item => {
                    return {
                        "type" : item.type,
                        "value" : item.value,
                    }
                }),
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    this.is_load = false;
                    this.feed = data.data;

                    self.work_obj.isLoaded = true;
                    self.work_obj.isRunning = false;

                    this.cur_org_id = this.provider.type;
                    if(this.feed.hasOwnProperty("organizations")) {
                        let orgs = this.feed.organizations.items;
                        if(orgs.length === 1) {
                            this.cur_org_id = orgs[0].id;
                        }
                    }

                    console.log(this.cur_org_id);
                    this.sync_menu();

                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        sync_menu() {
            let self = this;
            self.work_obj.isRunning = true;

            // Create a promise to start the chain
            let promise = Promise.resolve('OK');
            for (const [key, value] of Object.entries(self.feed)) {
                promise = promise.then((res) => {
                    return self.build_promise(key,value)
                });
            }

            promise.catch((response) => {
                self.work_obj.isRunning = false;
                EventBus.$emit('show_toast', {
                    err: "ERR",
                    type: "danger",
                    title: "operation_fail"
                })
            });
            promise.then((response) => {
                console.log('finish',response);
                EventBus.$emit('show_toast', {
                    err: "OK",
                    type: "success",
                    title: "Finish"
                })

                self.work_obj.isRunning = false;
            })
        },

        unmark_old(type) {
            return pos_api.patch('/pos/' + this.prov_id + '/organizations/' +  this.cur_org_id + "/" + type, {
                'type' : type,
            });
        },

        build_promise(idx,item)
        {
            let self = this;
            return this.unmark_old(idx).then((res) => {
                self.feed[idx].status = 'working';
                return this.make_batch(idx);
            }).then((res) => {
                console.log(res);
                self.feed[idx].status = 'finish';
                return res;

            }).catch((response) => {
                console.log('chain_err',response);
                self.feed[idx].status = 'error';
                EventBus.$emit('show_toast', {
                    err: "ERR:" + idx,
                    type: "danger",
                    title: "operation_fail"
                })
                throw new Error(response);
            });
        },

        async batchAxiosPromises(_items, cur_feed ,fn, callback) {
            let promiseChainResult = Promise.resolve();
            let self = this;
            let chunked_items = _items.chunk_inefficient(
                this.options.batchSize
            );
            let promiseChain = Promise.resolve();

            chunked_items.map(function (entity) {
                function getCurrentItem(item) {
                    return fn(item,cur_feed)
                        .then(({data}) => {
                            self.__l(item, "info", "SuccessFN -> Done");
                            if (callback != null) {
                                callback("OK");
                            }
                        }).catch(err => {
                            self.__l(item, "warn", "ErrorFN -> ERR");
                            if (callback != null) {
                                callback("ERR");
                            }
                        })
                }

                const makeNextPromise = (entity) => () => {
                    const allPromises = entity.map(item => getCurrentItem(item));
                    return Promise.all(allPromises).then(res => {
                        self.__l({}, "ok", "Chunk -> Done")
                    });
                };
                promiseChain = promiseChain.then(makeNextPromise(entity))
            });
            return promiseChain;
        },

        make_batch(idx) {
            let self = this;
            let cur_feed = self.feed[idx];
            return this.batchAxiosPromises(cur_feed.items, cur_feed, this.put_feed_item, res => {
                this.__l(res, "ok", "SYNC  -> " + idx);
                if (res === "OK") {
                    cur_feed.count_ok++;
                } else {
                    cur_feed.count_err++;
                }
            });
        },


        async put_feed_item(item,cur_feed) {
            console.log(cur_feed);
            let cur_type = cur_feed.cur_type;
            cur_type = cur_type.slice(0,-1);

            if(cur_type == 'categorie') {
                cur_type = 'category';
            }

            if(cur_type == 'citie') {
                cur_type = 'city';
            }

            if(cur_type == 'organization') {
                return pos_api.put('/pos/' + this.prov_id + '/organization', {
                    "store_item": item,
                });
            }

            return pos_api.put('/pos/' + this.prov_id + '/organizations/' +  this.cur_org_id +"/"+ cur_type, {
                "store_item": item,
            });
        },

    },



    computed : {

        can_sync() {
            return this.form_params.every(param => (param.value || '').length > 0);
        },

        radio_options() {
            return [
                {text: 'IMPORT_FULL_MENU',  value: "default"},
                {text: 'SYNC_WITH_POS', value: "manual"},
            ];
        },
    }
}
</script>

<style scoped>

</style>
